import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Rotate18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M2.75 1H1.25V6.75H7V5.25H4.00381C5.38237 3.43551 7.70796 2.50014 9.96182 2.85848C12.6025 3.27832 14.7319 5.40714 15.1526 8.04764C15.5733 10.6881 14.2107 13.3733 11.8313 14.5929C9.45182 15.8125 6.47635 15.3509 4.57832 13.4676L3.52181 14.5324C5.87536 16.8676 9.56495 17.4401 12.5155 15.9278C15.466 14.4155 17.1556 11.0859 16.6339 7.81165C16.1123 4.53742 13.4717 1.89769 10.1973 1.37709C7.36808 0.927257 4.45138 2.12199 2.75 4.42182V1Z'
      fill='currentColor'
    />
  </Svg>
);

Rotate18.displayName = 'Rotate18';
export default Rotate18;
